export default "__VITE_ASSET__sRd1wLwp__"